import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

function FeatureShowcaseGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-0.5 bg-cogBrand w-full overflow-hidden select-none font-sans">

      {/* Block 1: Fiber Optic Photo Tile with Logo */}
      <div
        className="relative p-8 flex flex-col items-center justify-center min-h-[320px] overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://static.vecteezy.com/system/resources/thumbnails/070/688/817/small/fiber-optic-cables-glowing-with-purple-and-blue-light-futuristic-technology-and-data-transmission-photo.jpeg')",
        }}
      >

        <div className="absolute inset-0 bg-cogInk/70 mix-blend-multiply pointer-events-none" />

        <div
          className="absolute inset-0 opacity-20 pointer-events-none bg-cover bg-bottom mix-blend-screen"
          style={{
            backgroundImage: 'radial-gradient(circle, rgba(3,152,210,0.35) 1px, transparent 1.5px)',
            backgroundSize: '16px 16px',
            maskImage: 'linear-gradient(to top, black, transparent 70%)',
            WebkitMaskImage: 'linear-gradient(to top, black, transparent 70%)',
            transform: 'skewY(-4deg) translateY(15%)',
          }}
        />

        <div className="relative z-10 flex items-center justify-center w-full h-full">
          <img
            src="logo.png"
            alt="Google Logo"
            className="h-46 w-44 object-contain brightness-0 invert"
          />
        </div>
      </div>

      {/* Block 2: AI is ready Solid Blue Tile */}
      <div className="bg-cogCyan p-8 flex flex-col justify-between text-cogLight min-h-[320px]">
        <div>
          <h3 className="text-2xl font-bold tracking-tight leading-snug mb-3">
      High-Precision Manufacturing
          </h3>
          <p className="text-sm text-cogLight/80 font-light leading-relaxed max-w-[28ch]">
Our manufacturing combines precision assembly and modern production techniques to deliver high-quality wiring harnesses. Every product is built for consistency, durability, and performance.
          </p>
        </div>
        <Link
          to="/services"
          className="group inline-flex items-center gap-1.5 text-xs font-bold tracking-wider border-b border-cogLight/50 w-max pb-0.5 hover:border-cogLight transition-colors duration-200"
        >
          READ MORE
          <ArrowRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-1" />
        </Link>
      </div>

      {/* Block 3: City Skyline Photo Tile */}
      <div className="relative group min-h-[320px] overflow-hidden">
        <img
          src="https://www.zuken.com/en/wp-content/uploads/sites/2/2020/09/mbse-wireharness-1510x731.jpg"
          alt="nexten European Night Cityscape Skyline"
          className="absolute inset-0 w-full h-full object-cover object-center scale-100 group-hover:scale-105 transition-transform duration-700 ease-out pointer-events-none"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-cogInk/50 via-transparent to-transparent" />
      </div>

      {/* Block 4: DTW Ignite Gradient Blue Tile */}
      <div className="bg-gradient-to-br from-cogCyan to-cogCyan p-8 flex flex-col justify-between text-cogLight min-h-[320px]">
        <div>
          <h3 className="text-2xl font-bold tracking-tight leading-snug mb-3">
          Comprehensive Quality Assurance
          </h3>
          <p className="text-sm text-cogLight/80 font-light leading-relaxed max-w-[28ch]">
         Every wiring harness undergoes rigorous inspection and testing to meet customer and industry standards. Our quality-driven approach ensures reliable performance before delivery.
          </p>
        </div>
        <Link
          to="/services"
          className="group inline-flex items-center gap-1.5 text-xs font-bold tracking-wider border-b border-cogLight/50 w-max pb-0.5 hover:border-cogLight transition-colors duration-200"
        >
          READ MORE
          <ArrowRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-1" />
        </Link>
      </div>

    </div>
  );
}

export default FeatureShowcaseGrid;